export default __webpack_public_path__ + "media/zurb/img/playground/ux-metrics-diagram-e9ef5b5c769c9aa732369621f7370bb8.png";